// extracted by mini-css-extract-plugin
export default {"mainLayout":"AppLayoutStyles_mainLayout__Kt6eJ","layout":"AppLayoutStyles_layout__kLoVT"};